"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@legacy-vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconColourPalette.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconColourPalette = function IconColourPalette(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.633 13.082A3.387 3.387 0 0 1 2.5 12c0-3.59 4.25-6.5 9.5-6.5s9.5 2.91 9.5 6.5-4.25 6.387-9.5 6.5c-2.234.047-3.691-.492-3.809-.543-.71-.305-.941-.89-.152-2.117.934-1.453 1.613-2.965.086-3.305-1.309-.285-2.668 1.363-3.95 1.516a1.397 1.397 0 0 1-1.542-.969Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.66 15.5c0-.18-.297-.328-.66-.328-.363 0-.66.148-.66.328 0 .18.297.328.66.328.363 0 .66-.148.66-.328Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.992 15.5c0-.273-.445-.492-.992-.492-.547 0-.992.219-.992.492s.445.492.992.492c.547 0 .992-.219.992-.492Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.414 15.5c0-.113-.187-.203-.414-.203-.227 0-.414.09-.414.203 0 .113.187.203.414.203.227 0 .414-.09.414-.203Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.164 15.5c0-.047-.074-.082-.164-.082-.09 0-.164.035-.164.082s.074.082.164.082c.09 0 .164-.035.164-.082Zm4.996-2c0-.18-.297-.328-.66-.328-.363 0-.66.148-.66.328 0 .18.297.328.66.328.363 0 .66-.148.66-.328Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.492 13.5c0-.273-.445-.492-.992-.492-.547 0-.992.219-.992.492s.445.492.992.492c.547 0 .992-.219.992-.492Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.914 13.5c0-.113-.187-.203-.414-.203-.227 0-.414.09-.414.203 0 .113.187.203.414.203.227 0 .414-.09.414-.203Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.664 13.5c0-.047-.074-.082-.164-.082-.09 0-.164.035-.164.082s.074.082.164.082c.09 0 .164-.035.164-.082ZM17.16 10c0-.18-.297-.328-.66-.328-.363 0-.66.148-.66.328 0 .18.297.328.66.328.363 0 .66-.148.66-.328Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.492 10c0-.273-.445-.492-.992-.492-.547 0-.992.219-.992.492s.445.492.992.492c.547 0 .992-.219.992-.492Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.914 10c0-.113-.187-.203-.414-.203-.227 0-.414.09-.414.203 0 .113.187.203.414.203.227 0 .414-.09.414-.203Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.664 10c0-.047-.074-.082-.164-.082-.09 0-.164.035-.164.082s.074.082.164.082c.09 0 .164-.035.164-.082ZM13.16 8.5c0-.18-.297-.328-.66-.328-.363 0-.66.148-.66.328 0 .18.297.328.66.328.363 0 .66-.148.66-.328Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.492 8.5c0-.273-.445-.492-.992-.492-.547 0-.992.219-.992.492s.445.492.992.492c.547 0 .992-.219.992-.492Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.914 8.5c0-.113-.187-.203-.414-.203-.227 0-.414.09-.414.203 0 .113.187.203.414.203.227 0 .414-.09.414-.203Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.664 8.5c0-.047-.074-.082-.164-.082-.09 0-.164.035-.164.082s.074.082.164.082c.09 0 .164-.035.164-.082Zm-3.992.512c0-.18-.293-.328-.66-.328-.364 0-.66.148-.66.328 0 .183.296.328.66.328.367 0 .66-.145.66-.328Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.004 9.012c0-.27-.441-.492-.992-.492-.547 0-.992.222-.992.492 0 .273.445.492.992.492.55 0 .992-.219.992-.492Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.426 9.012c0-.114-.184-.203-.414-.203-.227 0-.414.09-.414.203 0 .113.187.207.414.207.23 0 .414-.094.414-.207Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.176 9.012c0-.043-.07-.082-.164-.082-.09 0-.164.039-.164.082 0 .047.074.082.164.082.093 0 .164-.035.164-.082Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })));
};

IconColourPalette.displayName = "IconColourPalette";
var _default = IconColourPalette;
exports["default"] = _default;
//# sourceMappingURL=IconColourPalette.js.map